// src/rbac/RequirePermission.tsx
import React from 'react';
import { useHasPermission } from './useRbac';

/**
 * Renders children only if the current user holds `perm`. Used to gate the
 * Administration pages and individual write actions within them.
 */
export const RequirePermission: React.FC<{
  perm: string;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}> = ({ perm, fallback, children }) => {
  const allowed = useHasPermission(perm);
  if (!allowed) {
    return (
      <>
        {fallback ?? (
          <div className="py-16 text-center text-muted-foreground">
            You don't have permission to view this page.
          </div>
        )}
      </>
    );
  }
  return <>{children}</>;
};

export default RequirePermission;
